// extracted by mini-css-extract-plugin
export default {"about-info":"RnDAbout_about-info__dGYHY","about-text":"RnDAbout_about-text__Zh4Rl","about-img":"RnDAbout_about-img__JesZu"};